import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import useCompanyState, { ICompanyProfileStep } from '@/states/company.state';

export const useCompanyProfileSteps = () => {
  const { setCompanyProfileSteps } = useCompanyState();

  const query = useQuery(
    ['company-profile-steps'],
    async () => {
      const url = `${env.apiTasklistBaseUrl}/api/v1/compro/company-profile-steps`;
      const { data } = await axiosInstance.get(url);
      return data.data as ICompanyProfileStep[];
    },
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );

  // Sync React Query data to Zustand store
  useEffect(() => {
    if (query.data) {
      setCompanyProfileSteps(query.data);
    }
  }, [query.data, setCompanyProfileSteps]);

  return query;
};
